<app-vle-header *ngIf="!isShowHeaderFooter"></app-vle-header>
<router-outlet></router-outlet>
<app-vle-footer *ngIf="!isShowHeaderFooter"></app-vle-footer>